<!-- 需求管理 -->
<template>
  <div class="release">
    <!-- 背景图 -->
    <TopImg
      :title="topImg.title"
      :content="topImg.content"
      :image="topImg.bgImg"
      :bl="topImg.bl"
      :aLink="topImg.aLink"
      :blName="topImg.blName"
    ></TopImg>
    <div class="barPath width">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/release' }">供需市场</el-breadcrumb-item>
        <el-breadcrumb-item>需求管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 快速查找 -->
    <div class="fastSoo width">
      <div class="fastSooTitle">
        <div class="sooType clearfix">
          <div class="tt">需求类别：</div>
          <span
            :class="i==index?'active':''"
            v-for="(item,i) in sooListOne"
            :key="i"
            :index="i"
            @click="oneTitle(item.id,i)"
          >{{item.name}}</span>
        </div>
        <div class="genre clearfix">
          <div class="tt">需求状态：</div>
          <span
            :class="item.id==index1?'active':''"
            v-for="(item,i) in sooListTwo"
            :key="i"
            :index1="i"
            @click="twoTitle(item.id,i)"
          >{{item.name}}</span>
        </div>
        <div class="way clearfix">
          <div class="tt">提交时间：</div>
          <span
            :class="i==index2?'active':''"
            v-for="(item,i) in sooListThree"
            :key="i"
            :index2="i"
            @click="threeTitle(item.id,i)"
          >{{item.name}}</span>
        </div>
        <div class="way clearfix">
          <div class="tt">结束时间：</div>
          <span
            :class="i==index3?'active':''"
            v-for="(item,i) in sooListFour"
            :key="i"
            :index3="i"
            @click="fourTitle(item.id,i)"
          >{{item.name}}</span>
        </div>
        <div class="sooInput">
          <el-input placeholder="请输入内容" v-model="soo.names">
            <template slot="append">
              <el-button type="primary" @click="sousuo()">搜索</el-button>
            </template>
          </el-input>
        </div>
      </div>

      <div class="appItemList">
        <div class="appItem" v-for="(item,i) in dataList.data" :key="i">
          <div class="appItemTitle">
            <span>需求：</span>
            <strong>{{item.title}}</strong>
          </div>
          <div class="appItemCon">
            <div class="pp">
              <strong>需求方：</strong>
              <span>{{item.corporate}}</span>
            </div>
            <div class="pp">
              <strong>类型：</strong>
              <span v-if="item.type == 1">软件服务</span>
              <span v-if="item.type == 2">硬件服务</span>
              <span v-if="item.type == 3">智能设备</span>
            </div>
            <div class="pp">
              <strong>提交时间：</strong>
              <span>{{item.add_time | formatDate4}}</span>
            </div>
            <div class="pp">
              <strong>结束时间：</strong>
              <span>{{item.end_time | formatDate4}}</span>
            </div>
            <div class="pp">
              <strong>需求状态：</strong>
              <span v-if="item.status == 4">完成</span>
              <span v-if="item.status == 5">服务商招标</span>
              <span v-if="item.status == 6">预选服务商</span>
              <span v-if="item.status == 7">线下对接</span>
            </div>
            <div class="pp">
              <el-button type="primary" @click="goto(item.id)">查看详情</el-button>
            </div>
          </div>
        </div>

        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="soo.pages"
          :page-size="10"
          layout="total,prev, pager, next, jumper"
          :total="dataList.total"
          prev-text="上一页"
          next-text="下一页"
        ></el-pagination>
      </div>
    </div>
    <!-- 底部 -->
    <div class="el-footer">
      <Footer />
    </div>
  </div>
</template>

<script>
import TopImg from '../components/TopImg'
import Footer from '../components/Footer.vue'
export default {
  name: '',
  components: { TopImg, Footer },
  props: {},
  data() {
    return {
      topImg: {
        title: '需求管理',
        bgImg: require('../assets/images/u2717.jpg'),
        content:
          '软硬件服务需求市场，致力于降低企业成本 使用维护可靠便捷 服务专业到位',
        bl: true,
        aLink: 'issue',
        blName: '需求发布',
      },
      soo: {
        pages: 1,
        names: '',
        type: '',
        status: '',
        addtime: '',
        endtime: '',
      },
      dataList: [],
      sooListOne: [
        { id: 0, name: '全部' },
        { id: 1, name: '软件服务' },
        { id: 2, name: '硬件服务' },
        { id: 3, name: '智能设备' },
      ],
      sooListTwo: [
        { id: 0, name: '全部' },
        { id: 5, name: '服务商招标' },
        { id: 6, name: '预选服务商' },
        { id: 7, name: '线下对接' },
        { id: 4, name: '完成' },
      ],
      sooListThree: [
        { id: 0, name: '全部' },
        { id: 1, name: '三天内' },
        { id: 2, name: '7天内' },
        { id: 3, name: '15天内' },
        { id: 4, name: '一个月内' },
        { id: 5, name: '三个月内' },
      ],
      sooListFour: [
        { id: 0, name: '全部' },
        { id: 1, name: '三天内' },
        { id: 2, name: '7天内' },
        { id: 3, name: '15天内' },
        { id: 4, name: '一个月内' },
        { id: 5, name: '三个月内' },
      ],
      index: 0,
      index1: 0,
      index2: 0,
      index3: 0,
      priceIndex: 0,
      countIndex: 0,
    }
  },
  computed: {},
  watch: {},
  created() {
    this.getListData()
  },
  mounted() {},
  methods: {
    async getListData() {
      const res = await this.$http.post('/demandList', this.soo)
      console.log(res)
      this.dataList = res.data
    },
    async oneTitle(i, j) {
      this.index = j
      this.soo.type = i
      this.getListData()
    },
    async twoTitle(i, j) {
      this.index1 = j
      this.soo.status = i
      this.getListData()
    },
    async threeTitle(i, j) {
      this.index2 = j
      this.soo.addtime = i
      this.getListData()
    },
    async fourTitle(i, j) {
      this.index3 = j
      this.soo.endtime = i
      this.getListData()
    },
    async sousuo(i, j) {
      this.getListData()
    },
    goto(i) {
      this.$router.push({
        name: 'releaseDetails',
        params: {
          //params 传递参数
          ids: i,
        },
      })
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`)
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`)
      this.soo.pages = val
      this.getListData()
    },
  },
}
</script>

<style lang="less" scoped>
.barPath {
  height: 48px;
  line-height: 48px;
  background-color: #fff;
  padding-left: 20px;
  box-sizing: border-box;
  margin-bottom: 10px;
  .el-breadcrumb {
    line-height: 48px;
    font-size: 16px !important;
  }
}
.fastSoo {
  .fastSooTitle {
    background-color: #fff;
    padding: 10px;
    margin-bottom: 10px;
    .sooType,
    .genre,
    .way {
      margin: 10px 0;
      .tt {
        float: left;
        max-width: 80px;
      }
      span {
        float: left;
        padding: 0 20px;
        text-align: center;
        cursor: pointer;
      }
      span:hover {
        color: #0079fe;
      }
      .active {
        color: #0079fe;
      }
    }
    .sooInput {
      width: 600px;
      margin: 20px 0;
    }
  }

  .appItemList {
    .appItem {
      background-color: #fff;
      margin-bottom: 10px;
      padding: 10px 20px;
      .appItemTitle {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 10px;
        margin-top: 10px;
        span {
          flex: 1;
          max-width: 80px;
          font-weight: 700;
          font-size: 16px;
        }
        strong {
          flex: 1;
          font-size: 16px;
          color: #1677ff;
        }
      }
      .appItemCon {
        display: flex;
        align-items: center;
        margin-bottom: 30px;
        .pp {
          flex: 1;
          display: flex;
          strong {
            flex: 1;
            max-width: 80px;
          }
        }
      }
    }
  }
}
.el-pagination {
  text-align: center;
  padding: 20px 0;
  background-color: #fff;
}
</style>
